// api.js
import {loginUserStore} from "@/stores/loginUserStore";
import callApi from "@/api/api";


async function refreshToken(){
    console.info("refreshToken loading")
    if(!JSON.parse(localStorage.getItem("loginUserStore"))){
        return;
    }
    // 使用callApi函数调用接口
    let requestData = {
        "refreshToken": JSON.parse(localStorage.getItem("loginUserStore")).refresh_token
    }
    const data = await callApi('/infoaccountadmin/userLogin/loginForRefreshToken', 'post' , requestData);
    if(data){
        loginUserStore().setLoginUser(data.data);
        return "success";
    }
    return;
}

// 导出接口调用函数
export default refreshToken;